import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class EmailLink extends PureComponent {

  static propTypes = {
    email: PropTypes.string.isRequired,
    color: PropTypes.string
  };

  static defaultProps = {
    color: '#000000',
  };

  state = {
    isHovered: false
  };

  onMouseEnter = () => this.setState({ isHovered: true });
  onMouseLeave = () => this.setState({ isHovered: false });

  // lifecycle
  render() {
    const { email, color } = this.props;
    const { isHovered } = this.state;
    return (
      <span
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <a
          style={{
            color: isHovered ? color : 'inherit',
            textDecoration: 'inherit',
            borderBottom: isHovered ? `1px solid ${color}` : 'inherit'
          }}
          href={`mailto:${email}`}>
          {email}
        </a>
      </span>
    );
  }
}